import { render } from "./EditInvoice.vue?vue&type=template&id=9307567a&scoped=true"
import script from "./EditInvoice.vue?vue&type=script&lang=ts"
export * from "./EditInvoice.vue?vue&type=script&lang=ts"

import "./EditInvoice.vue?vue&type=style&index=0&id=9307567a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9307567a"

export default script